/* eslint-disable no-unused-vars */
import { Text, Box } from '@chakra-ui/react';
import PlaceHolder from 'assets/placeholder.png';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function CategoryCard({ category, isub }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const getSingleCategory = (id) => {
        // dispatch(get_category_details(id));
        navigate(`/dashboard/single-category/${id}`);
    };
    return (
        <Box
            p="5"
            gap="2"
            borderRadius="md"
            padding="0"
            onClick={() => {
                getSingleCategory(category?.category_id);
            }}
            cursor="pointer">
            <Box
                backgroundSize={'contain'}
                backgroundRepeat={'no-repeat'}
                backgroundImage={category?.image}
                backgroundPosition={'center'}
                w="full"
                minW={'max'}
                alt={category?.name || 'Category image'}
                objectFit="cover"
                h="10rem"
                fallbackSrc={PlaceHolder}
                borderRadius="md">
                <Box
                    padding={'20px'}
                    width={'100%'}
                    display={'flex'}
                    flexDir="column"
                    borderRadius="md"
                    height={'100%'}
                    backgroundColor={'blackAlpha.500'}>
                    <Box>
                        <Text
                            color="white"
                            fontSize={'24px'}
                            fontWeight="bold"
                            textTransform="capitalize">
                            {category?.name?.toLowerCase()}
                        </Text>
                        <Text fontSize={'16px'} color="whiteAlpha.800" fontWeight="bold">
                            {category?.product_count} Items
                        </Text>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
